import { render, staticRenderFns } from "./BodyShaming.vue?vue&type=template&id=2b927b7f&scoped=true&"
import script from "./BodyShaming.vue?vue&type=script&lang=js&"
export * from "./BodyShaming.vue?vue&type=script&lang=js&"
import style0 from "./BodyShaming.vue?vue&type=style&index=0&id=2b927b7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b927b7f",
  null
  
)

export default component.exports